class UnauthenticatedResponseInterceptor {
    onError = (error)=>{
        if (401 === error.statusCode) {
            const reloadUrlBuilder = new URL(globalThis.location.href);
            this.addExternalSystemTypeParameter(reloadUrlBuilder);
            const reloadUrl = reloadUrlBuilder.toString();
            if (globalThis.location.href === reloadUrl) globalThis.location.reload();
            else globalThis.location.replace(reloadUrl);
        }
        return Promise.reject(error);
    };
    addExternalSystemTypeParameter(url) {
        const externalSystemType = globalThis.sessionStorage['Templafy/Integrations/ExternalSystemType'];
        if (externalSystemType) url.searchParams.set('externalSystemType', externalSystemType);
    }
}
export { UnauthenticatedResponseInterceptor };
